
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FileUpload from "@/components/scope/file-upload.vue";
import Editor from "@common/src/components/scope/editor/index.vue";
import { Table } from "@common/src/utils/decorator";
import { getImageSize, emptyToLine, commonRouterPush } from "@common/src/utils/common";
import CouponDiscountContent from "../components/coupon-discount-content.vue";
import dayjs from "dayjs";
import { checkMoney, isPositiveIntegerZero, isPositiveInteger } from "@common/src/utils/verify";
import { addCurrencyUnit } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";
import { InjectFunction } from "@common/src/utils/decorator";
import CampaignTempItem from "./components/campaign-temp-item.vue";
import SwitchAutoTips from "../components/switch-auto-tips.vue";
import CouponSelector from "./components/coupon-selector.vue";
import CouponContent from "../components/coupon-discount-content.vue";
import ImgLoader from "@common/src/components/scope/img-loader/index.vue";

const app = namespace("app");
const store = namespace("store");
const campaign = namespace("campaign");
const base = namespace("base");
const marketing = namespace("marketing");
const defaultBg = "rgb(236,246,245)";
const defaultBannerUrl = "https://static.gtech.asia/static/speedbiz/minipro/accumulate-banner.jpg";
@InjectFunction("dayjs", "permitApp", "appCode", "addCurrencySymbol")
@Component({
  components: {
    FileUpload,
    Editor,
    CouponDiscountContent,
    CampaignTempItem,
    SwitchAutoTips,
    CouponSelector,
    CouponContent,
    ImgLoader
  }
})
@Table("loadListData", { pageSize: 10 })
export default class CollectCustomerEdit extends Vue {
  @store.State storeData;
  @campaign.Action queryOpFissionList;
  @base.Action getDictionaryList;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @app.State autoPopOpTemplate;
  @app.Mutation setPBPX;
  @marketing.Action queryCardTemplateList;
  @marketing.Action updateFission;
  @marketing.Action insertFission;
  @marketing.Action queryFissionCampaign;
  emptyToLine = emptyToLine;
  commonRouterPush = commonRouterPush;
  addCurrencyUnit = addCurrencyUnit;
  campaignForm: any = {
    id: "defalut", // 上传图片用的
    campaignName: "",
    campaignBeginTime: "",
    campaignEndTime: "",
    campaignImage: "",
    campaignThumbnail: "", // 活动缩略图(分享图)
    campaignDesc: "",
    campaignContext: "",
    campaignContext2: "",
    campaignImageColor: "",
    fissionPrize: {
      bindCode: "",
      prizeAmount: "",
      prizeQty: ""
    },
    // 非业务直接参数
    time: [],
    bannerType: "customize", // default customize
    fissionCouponPrizeList: [] // 优惠券列表
  };
  dayjs = dayjs;
  refreshFlag: boolean = true;
  showCardSelector: boolean = false;
  get campaignFormRules() {
    return {
      campaignName: [
        { required: true, message: t("v210801.please-enter-the-campaign-title"), trigger: "blur" },
        { max: 14, message: t("v210801.the-maximum-length"), trigger: "blur" }
      ],
      "fissionPrize.bindCode": { required: true, message: t("marketing.please-select-card-template") },
      time: { type: "array", required: true, message: t("v210801.please-select-an"), trigger: "change" },
      campaignImage: { required: true, validator: this.checkFrontImage },
      campaignThumbnail: { required: true, validator: this.checkFrontImage },
      campaignContext: [{ required: true, message: t("v210831.please-enter-the-activity-content"), trigger: "blur" }]
    };
  }
  checkFrontImage(rule, value, callback) {
    if (!value) {
      callback(new Error(t("v210801.please-upload-pictures") as string));
    } else {
      callback();
    }
  }

  handleBannerChange(val) {
    if (val === "default") {
      this.campaignForm.campaignImageColor = defaultBg;
      this.campaignForm.campaignImage = defaultBannerUrl;
      this.defaultBannerList = [];
    } else {
      this.$nextTick(() => {
        this.campaignForm.campaignImage = "";
      });
    }
  }
  get breadData() {
    return [
      { name: t("v210801.fission-activity"), path: "/marketing/campaign/fission-campagin" },
      {
        name: this.isAdd ? t("v210801.new-fission-activity") : t("v210801.edit-fission-activity")
      }
    ];
  }
  searchForm = {
    cardTemplateName: "",
    enableStatus: 1, //（1：启用、0：禁用）integer 只显示启用的卡
    cardType: 1 //（1：套餐卡、2：储蓄卡）integer 0630这个版本先写死
  };
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  selectedRow: any = {};
  confirmSelecteRow: any = {
    bindCode: undefined,
    prizeAmount: undefined,
    prizeQty: undefined
  };
  handleRowSelect(rows) {
    this.selectedRow = rows.length > 0 ? rows[0] : {};
  }
  checkable(row) {
    return !Object.keys(this.selectedRow).length || this.selectedRow.cardTemplateCode === row.cardTemplateCode;
  }
  handleSelectedCoupon() {
    if (!this.selectedRow) {
      return this.$message.error(t("v210801.please-select-a") as string);
    }
    this.confirmSelecteRow = Object.assign({}, this.selectedRow);
    this.campaignForm.fissionPrize.bindCode = this.selectedRow.cardTemplateCode;
    this.showCardSelector = false;
  }
  get couponSearchList() {
    return [
      {
        label: t("v210801.card-template-name"),
        type: "input",
        value: "",
        prop: "cardTemplateName"
      }
    ];
  }
  campaignStatusList: any = [];
  get isAdd() {
    return this.$route.name === "fissionCampaginAdd";
  }
  created() {
    this.setPBPX(52);
    this.init();
  }
  get id() {
    return this.$route.params.id;
  }
  get copyCode() {
    return this.$route.query.copyCode;
  }
  defaultBannerList: any = [];
  defaultShareList: any = [];
  storeTypesList: any = [];
  storeTypeList: any = [];
  init() {
    this.getDictionaryList("coupon_activity_status").then(data => {
      this.campaignStatusList = data.filter(item => item.value !== "05" && item.value !== "07");
    });
    if (!this.isAdd || this.copyCode) {
      this.queryFissionCampaign({ campaignCode: this.id || this.copyCode }).then(data => {
        this.campaignInfoSet(data.data);
      });
    }
    if (this.appCode === "speedbiz") {
      this.queryOpFissionList().then(data => {
        this.opCampaignList = data.data;
        if (this.autoPopOpTemplate && this.opCampaignList.length > 0 && this.isAdd && !this.copyCode) {
          this.showSelectOpTemplate = true;
        }
      });
    } else if (this.appCode === "speedbiz-operation") {
      this.getDictionaryList("store_type").then(data => {
        this.storeTypeList = data;
      });
    }
  }

  handleRemoveCard() {
    this.selectedRow = {};
    this.confirmSelecteRow = {};
  }
  handleBannerUploadSuccess(url) {
    (this.$refs.campaignForm as any).validateField("campaignImage");
    this.getImageColor(url);
  }
  async handleShowCard() {
    if (this.appCode === "speedbiz-operation" && (this.campaignForm?.storeTypeList || []).length < 1) {
      return this.$message.error(t("v213.please-select-the-applicable-store-first"));
    }
    this.showCardSelector = true;
    await this.loadListData();
    // setTimeout(() => {
    //   this.$nextTick(() => {
    //     (this.$refs["cardTemplateTable"] as any).toggleRowSelection(this.selectedRow, true);
    //   });
    // }, 1000);
  }
  getImageColor(url) {
    console.log(url);
    const _this = this;
    let canvas = document.createElement("canvas"),
      ctxt = canvas.getContext && canvas.getContext("2d");
    const img = new Image();
    // 要求跨域处理
    img.crossOrigin = "Anonymous";
    img.src = url; //src也可以是从文件选择控件中取得。
    img.onload = () => {
      let [width, height] = getImageSize(img);
      canvas.height = height;
      canvas.width = width;
      ctxt.drawImage(img, 0, 0);
      const data = ctxt.getImageData(~~(width / 2), height - 2, 1, 1).data; //读取整张图片的像素。
      let [r, g, b] = data;
      _this.campaignForm.campaignImageColor = `rgb(${[r, g, b].join()})`;
    };
  }
  cardTemplateList: any = [];
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryCardTemplateList({
      ...this.searchForm,
      pageNum: 1,
      pageSize: 999,
      storeTypeList: this.campaignForm.storeTypeList
    }).then(data => {
      this.cardTemplateList = data.data.list;
      return data;
    });
  }
  saveCampaign() {
    (this.$refs.campaignForm as any).validate(valid => {
      if (valid) {
        this.campaignForm.campaignBeginTime = this.campaignForm.time[0];
        this.campaignForm.campaignEndTime = this.campaignForm.time[1];
        if (this.appCode === "speedbiz-operation") {
          this.campaignForm.storeTypes = this.campaignForm.storeTypeList.join();
        }
        if (this.confirmSelecteRow.cardTemplateCode) {
          if (!this.confirmSelecteRow.prizeAmount || !this.confirmSelecteRow.prizeQty) {
            return this.$message.error(t("v210801.please-complete-the") as string);
          }
          if (
            (this.confirmSelecteRow.prizeQty && !isPositiveIntegerZero(this.confirmSelecteRow.prizeQty)) ||
            Number(this.confirmSelecteRow.prizeQty) === 0
          ) {
            return this.$message.error(t("v210801.the-maximum-number") as string);
          }
          if (this.confirmSelecteRow.prizeAmount && !checkMoney(this.confirmSelecteRow.prizeAmount).success) {
            return this.$message.error(t("v210801.the-activity-amount") as string);
          }
          if (!this.confirmSelecteRow?.cardTemplateCode) {
            return this.$message.error(t("marketing.please-select-card-template") as string);
          } else {
            this.campaignForm.fissionPrize = {
              bindCode: this.confirmSelecteRow.cardTemplateCode,
              prizeAmount: this.confirmSelecteRow.prizeAmount,
              prizeQty: this.confirmSelecteRow.prizeQty
            };
          }
        }
        if (dayjs(this.campaignForm.time[1]).toDate().getTime() < Date.now()) {
          return this.$message.error(t("v210801.end-time-cannot") as string);
        }
        if (this.campaignForm.fissionCouponPrizeList && this.campaignForm.fissionCouponPrizeList.length > 0) {
          if (this.campaignForm.fissionCouponPrizeList.some(item => !isPositiveInteger(item.prizeQty))) {
            return this.$message.error(t("v213.the-number-of-coupons-is-a-positive-integer"));
          }
        }
        this.btnStartLoading();

        if (this.isAdd) {
          this.insertFission(this.campaignForm)
            .then(() => {
              this.isAdd
                ? this.$message.success(t("v210801.activity-created-successfully") as string)
                : this.$message.success(t("v210801.activity-edited-successfully") as string);
              this.$router.push("/marketing/campaign/fission-campagin");
            })
            .finally(() => {
              this.btnStopLoading();
            });
        } else {
          this.updateFission(this.campaignForm)
            .then(() => {
              this.isAdd
                ? this.$message.success(t("v210801.activity-created-successfully") as string)
                : this.$message.success(t("v210801.activity-edited-successfully") as string);
              this.$router.push("/marketing/campaign/fission-campagin");
            })
            .finally(() => {
              this.btnStopLoading();
            });
        }
      }
    });
  }
  showSelectOpTemplate: boolean = false; // 选择op活动模板弹窗
  opCampaignList: any = [];
  handleSelectTemplate() {
    this.showSelectOpTemplate = true;
  }
  selectedTemp: any = {};
  handleTempClick(campaign) {
    this.selectedTemp = campaign;
  }
  handleConfirmTemplate() {
    this.showSelectOpTemplate = false;
    this.campaignInfoSet(this.selectedTemp, "quote");
  }
  campaignInfoSet(campaignInfo, type?) {
    campaignInfo.time = [
      dayjs(campaignInfo.campaignBeginTime).format("YYYYMMDDHHmmss"),
      dayjs(campaignInfo.campaignEndTime).format("YYYYMMDDHHmmss")
    ];
    if (this.copyCode || type === "quote") {
      delete campaignInfo.campaignCode;
    }
    if (campaignInfo.campaignImage === defaultBannerUrl) {
      campaignInfo.bannerType = "default";
    } else {
      campaignInfo.bannerType = "customize";
      this.defaultBannerList = [{ url: campaignInfo.campaignImage }];
    }
    this.defaultShareList = [{ url: campaignInfo.campaignThumbnail }];
    if (this.appCode === "speedbiz-operation") {
      campaignInfo.storeTypeList = campaignInfo.storeTypes.split(",");
    }
    if (campaignInfo.fissionPrize) {
      this.confirmSelecteRow = Object.assign(campaignInfo.fissionPrize.cardTemplateResult, {
        cardTemplateCode: campaignInfo.fissionPrize.bindCode,
        bindCode: campaignInfo.fissionPrize.bindCode,
        prizeAmount: campaignInfo.fissionPrize.prizeAmount,
        prizeQty: campaignInfo.fissionPrize.prizeQty
      });
    }
    this.refreshFlag = false;
    this.$nextTick(() => {
      this.refreshFlag = true;
      this.campaignForm = Object.assign({}, campaignInfo);
    });
  }
  showConponSelector: boolean = false;
  handleShowCoupon() {
    if (this.appCode === "speedbiz-operation" && (this.campaignForm?.storeTypeList || []).length < 1) {
      return this.$message.error(t("v213.please-select-the-applicable-store-first"));
    }
    if (!this.campaignForm.time || this.campaignForm.time.length < 2) {
      return this.$message.error(t("v213.please-select-the-activity-time-first"));
    }
    this.showConponSelector = true;
  }
  handleCouponSelectDone(val) {
    this.showConponSelector = false;
    val.slice(0).forEach(item => {
      if (!this.campaignForm.fissionCouponPrizeList.find(prize => prize.bindCode === item.activityCode)) {
        item.bindCode = item.activityCode;
        this.campaignForm.fissionCouponPrizeList.push(item);
      }
    });
  }
  handleRemoveCoupon(index) {
    this.campaignForm.fissionCouponPrizeList.splice(index, 1);
  }
  handleTimeChange() {
    this.campaignForm.fissionCouponPrizeList = [];
  }
  handleApplyStoresChange() {
    this.campaignForm.fissionCouponPrizeList = [];
    this.confirmSelecteRow = {
      bindCode: "",
      prizeAmount: "",
      prizeQty: ""
    };
    this.selectedRow = {};
    this.campaignForm.fissionPrize = {
      bindCode: "",
      prizeAmount: "",
      prizeQty: ""
    };
  }
}
